
export const emailRecipientTypes = [
        { name: "ICSO", field: "overviewRecipientType" },
        { name: "DR", field: "docRequestRecipientType" },
        { name: "INV", field: "inventoryRecipientType" },
        { name: "PL", field: "pickTicketRecipientType" },
        { name: "DT", field: "deliveryTicketType" }
    ];

export const emailRecipientLabels = [
        { name: 'overviewRecipientType', label: 'Overview' },
        { name: 'docRequestRecipientType', label: 'Document Request' },
        { name: 'inventoryRecipientType', label: 'Inventory' },
        { name: 'pickTicketRecipientType', label: 'Packing List' },
        { name: 'deliveryTicketType', label: 'Delivery Ticket'}
    ];